var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-chip-group', {
    staticClass: "flex-wrap"
  }, _vm._l(_vm.items, function (item) {
    return _c('v-chip', {
      key: item,
      attrs: {
        "large": "",
        "color": "grey-light",
        "text-color": "grey-dark"
      }
    }, [_c('span', {
      staticClass: "font-weight-regular"
    }, [_vm._v(_vm._s(item))])]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }